"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arqua-polesine": {
    "2cfb0d8b": [{
      "hkey": "ddbf6897",
      "slug": "arqua-polesine",
      "name": "Arquà Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "capobosco": [{
      "hkey": "ddbf6897",
      "slug": "arqua-polesine",
      "name": "Arquà Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b8cd1d3": [{
      "hkey": "ddbf6897",
      "slug": "arqua-polesine",
      "name": "Arquà Polesine",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "ddbf6897",
      "slug": "arqua-polesine",
      "name": "Arquà Polesine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;